import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { shippingActions } from "../store/shippingSlice";
import appConst from "../Utilities/appConst.json";

// Lets the (non-component) shipping thunk send the user back to /basketItems when the basket
// can't be recovered. The thunk sets state.shipping.redirectToBasketItems; we do the actual
// navigation here with the router's own history (iframe-safe — no module-level custom history).
// replace() (not push) so Back can't return to /shipping.
const BasketRedirectWatcher = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const redirectToBasketItems = useSelector(
    (state) => state.shipping.redirectToBasketItems
  );

  useEffect(() => {
    if (!redirectToBasketItems) return;
    dispatch(shippingActions.setRedirectToBasketItems(false));
    history.replace({
      pathname: appConst.SECOND_PAGE,
      search: location.search,
    });
  }, [redirectToBasketItems]);

  return null;
};

export default BasketRedirectWatcher;
